import createQRTransPointReducer from "./createQRTransPointReducer";
//---
export const qrTransPointReducer = {
    createQRTransPointReducer
}